// extracted by mini-css-extract-plugin
export default {"page":"SettingsPage_page__zuKiI"};